export const paymentOptionsStyles = {
	title: {
		textAlign: 'center',
		marginBottom: '24px',
	},

	content: {
		display: 'flex',
		justifyContent: 'center',
		flexDirection: 'column',
		width: '100%',
		gap: '12px',
		alignItems: 'center',
		paddingTop: '40px',
	},

	radio: {
		border: '1px solid var(--neutral-100)',
		maxWidth: '374px',
		width: '100%',
		borderRadius: '8px',

		'& .MuiRadio-root': {
			padding: 'unset',
			margin: '0 16px 0 0',
		},

		'& .MuiFormControlLabel-root': {
			marginLeft: '0px',
			marginRight: 'unset',
			padding: '16px',
			// width: '100%',
			height: '60px',
		},
	},

	activeRadio: {
		border: '1px solid var(--primary-500)',
	},

	radioLabel: {
		display: 'flex',
		alignItems: 'center',
	},

	radioTitle: {
		marginLeft: '8px',
	},
};
